// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrap":"spinnerWrap--chl6s"};